// extracted by mini-css-extract-plugin
export default {"Error":"Company_Error__HO6jQ","ErrorText":"Company_ErrorText__YPqHd"};